import { ViewConfig } from "@lib/views";
import { DATE_COLUMN_SIZE } from "@design-system/ViewTable/DefaultColumnSizes";
import { ChartOfAccountsTemplateApplyEntityColumn as ApplyCoaTemplateEntityColumn } from "@common/types/views/chartOfAccountsTemplateApplyEntitySelectionView";
import type { ApplyCoaTemplateEntitySelectionRow } from "./applyCoaTemplateEntitySelection.types";
import { ApplyCoaEntityNameCell } from "./cells/ApplyCoaEntityNameCell";
import { ApplyCoaEntityIndustriesCell } from "./cells/ApplyCoaEntityIndustriesCell";
import { ApplyCoaEntityBasisCell } from "./cells/ApplyCoaEntityBasisCell";
import { ApplyCoaEntityDateCell } from "./cells/ApplyCoaEntityDateCell";
import { ApplyCoaEntityTeamCell } from "./cells/ApplyCoaEntityTeamCell";
import { ApplyCoaEntityServicesCell } from "./cells/ApplyCoaEntityServicesCell";
import { ApplyCoaEntityOpenCell } from "./cells/ApplyCoaEntityOpenCell";

export { ApplyCoaTemplateEntityColumn };
export type { ApplyCoaEntityOpenCallbacks } from "./cells/ApplyCoaEntityOpenCell";

export const applyCoaTemplateEntitySelectionViewConfig: ViewConfig<
    ApplyCoaTemplateEntitySelectionRow,
    ApplyCoaTemplateEntityColumn,
    never
> = {
    columns: {
        [ApplyCoaTemplateEntityColumn.NAME]: {
            accessorKey: "name",
            name: "Client",
            header: "Client",
            cell: ApplyCoaEntityNameCell,
            immutable: true,
            minSize: 260,
            maxSize: 480,
        },
        [ApplyCoaTemplateEntityColumn.INDUSTRY]: {
            accessorKey: "industries",
            name: "Industry",
            header: "Industry",
            cell: ApplyCoaEntityIndustriesCell,
            minSize: 140,
            maxSize: 280,
        },
        [ApplyCoaTemplateEntityColumn.LAST_UPDATED]: {
            accessorKey: "coaLastUpdatedAt",
            name: "Updated on",
            header: "Updated on",
            cell: ApplyCoaEntityDateCell,
            ...DATE_COLUMN_SIZE,
        },
        [ApplyCoaTemplateEntityColumn.TEAM]: {
            accessorKey: "team",
            name: "Team",
            header: "Team",
            cell: ApplyCoaEntityTeamCell,
            minSize: 120,
            maxSize: 180,
        },
        [ApplyCoaTemplateEntityColumn.SERVICES]: {
            accessorKey: "services",
            name: "Services",
            header: "Services",
            cell: ApplyCoaEntityServicesCell,
            minSize: 160,
            maxSize: 360,
        },
        [ApplyCoaTemplateEntityColumn.BASIS]: {
            accessorKey: "bases",
            name: "Basis",
            header: "Basis",
            cell: ApplyCoaEntityBasisCell,
            minSize: 140,
            maxSize: 240,
        },
        // Hidden from column settings so it never surfaces in the apply wizard
        // (which doesn't list it in its view); the applied-entities drawer does.
        [ApplyCoaTemplateEntityColumn.APPLIED_AT]: {
            accessorKey: "appliedAt",
            name: "Applied",
            header: "Applied",
            cell: ApplyCoaEntityDateCell,
            ...DATE_COLUMN_SIZE,
            hiddenFromSettings: true,
        },
        [ApplyCoaTemplateEntityColumn.OPEN]: {
            accessorKey: "entityId",
            name: "Open",
            header: "",
            cell: ApplyCoaEntityOpenCell,
            minSize: 96,
            maxSize: 96,
            immutable: true,
            hiddenFromSettings: true,
        },
    },
    nesting: {
        enabled: true,
        expandColumn: ApplyCoaTemplateEntityColumn.NAME,
        childrenKey: "children",
    },
};
